module.exports = __webpack_public_path__ + "static/card-harbor-tours-2-30c3658058608e425e6e4a4c5ca7c802.jpg";